var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"brand-logo pull-left"},[_c('a',{attrs:{"href":_vm.href}},[_c('img',{attrs:{"src":_vm.image}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }